<template>
  <div>
    <a-card size="small" :loading="loading">
      <a-page-header title="研发任务统计图" />
      <a-tabs v-model="activeKey" size="small">
        <a-tab-pane key="1" tab="任务提审时效">
          <a-card size="small" :loading="loading">
            <template slot="title">
              <span style="margin-right: 4px">表单说明</span>
              <a-popover title="报表说明" placement="topLeft">
                <template slot="content">
                  <p>离线表计算有t+1的数据延迟</p>
                  <p>统计数据范围：任务完成时间在筛选时间内的所有任务（不包含非编码任务）</p>
                  <p>提审时间差计算公式为：该任务最后一次提审到qa的时间-该任务最后一次被置为开发完成的时间</p>
                  <p>时间差内过滤非工作时间</p>
                </template>
                <a-icon type="question-circle" />
              </a-popover>
            </template>
            <a-table v-if="team_data.length > 0" size="small" :pagination="false" :columns="columns" row-key="index" :data-source="team_data" :loading="loading">
              <span slot="team_name" slot-scope="text, record">{{ record.team_name }} </span>
              <span slot="less_than_half_per" slot-scope="text, record">
                <span v-if="record.total_num != 0">{{ ((record.less_than_half / record.total_num) * 100).toFixed(2) }}%</span>
                <span v-else>{{ '0.00%' }}</span>
              </span>
              <span slot="in_one_day_per" slot-scope="text, record">
                <span v-if="record.total_num != 0">{{ ((record.in_one_day / record.total_num) * 100).toFixed(2) }}%</span>
                <span v-else>{{ '0.00%' }}</span>
              </span>
              <span slot="more_than_one_day_per" slot-scope="text, record">
                <span v-if="record.total_num != 0">{{ ((record.more_than_one_day / record.total_num) * 100).toFixed(2) }}%</span>
                <span v-else>{{ '0.00%' }}</span>
              </span>
            </a-table>
          </a-card>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="任务规划量报表" :force-render="true">
          <task-point-trend :filter-form="filterForm" />
        </a-tab-pane>
        <a-tab-pane :key="3" tab="任务规划热力图" :force-render="true">
          <task-pre-heat :filter-form="filterForm" />
        </a-tab-pane>
        <a-tab-pane :key="4" tab="任务完成时效" :force-render="true">
          <task-dely :filter-form="filterForm" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <div v-if="taskList && taskList.length > 0">
      <task-to-qa-modal ref="taskListModal" :task-list="taskList" />
    </div>
  </div>
</template>
<script>
import { getDevWorkChart } from '@/api/data/noticeboard';
import { taskToQaTime } from '@/api/data/task';
import TaskPointTrend from '@/pages/data/components/TaskPointTrend.vue';
import TaskDely from '@/pages/data/components/TaskDely.vue';
import TaskPreHeat from '@/pages/data/components/TaskPreHeat.vue';
import TaskToQaModal from '@/pages/data/components/TaskToQaModal';

const columns = [
  {
    title: '名称',
    dataIndex: 'team_name',
    key: 'team_name',
    width: '10%',
    ellipsis: true,
    scopedSlots: { customRender: 'team_name' }
  },
  {
    title: '总任务数',
    dataIndex: 'total_num',
    key: 'total_num',
    width: '15%',
    sorter: (a, b) => a.total_num - b.total_num,
    ellipsis: true
  },
  {
    title: '半小时内提审数',
    dataIndex: 'less_than_half',
    key: 'less_than_half',
    width: '15%',
    sorter: (a, b) => a.less_than_half - b.less_than_half,
    ellipsis: true
  },
  {
    title: '半小时内提审占比',
    dataIndex: 'less_than_half_per',
    key: 'less_than_half_per',
    width: '15%',
    ellipsis: true,
    scopedSlots: { customRender: 'less_than_half_per' }
  },
  {
    title: '一天内提审数',
    dataIndex: 'in_one_day',
    key: 'in_one_day',
    sorter: (a, b) => a.in_one_day - b.in_one_day,
    width: '15%',
    ellipsis: true
  },
  {
    title: '一天内提审占比',
    dataIndex: 'in_one_day_per',
    key: 'in_one_day_pre',
    width: '15%',
    ellipsis: true,
    scopedSlots: { customRender: 'in_one_day_per' }
  },
  {
    title: '超过一天提审数',
    dataIndex: 'more_than_one_day',
    key: 'more_than_one_day',
    sorter: (a, b) => a.more_than_one_day - b.more_than_one_day,
    width: '15%',
    ellipsis: true
  },
  {
    title: '超过一天提审占比',
    dataIndex: 'more_than_one_day_per',
    key: 'more_than_one_day_per',
    width: '15%',
    ellipsis: true,
    scopedSlots: { customRender: 'more_than_one_day_per' }
  }
];
export default {
  components: { TaskPointTrend, TaskToQaModal, TaskDely, TaskPreHeat },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      activeKey: '1',
      taskData: {},
      taskList: [],
      data: {
        title: null,
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        params: {}
      },
      formData: {},
      team_data: [],
      correctionData: []
    };
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },

  methods: {
    onClick(team_id) {
      this.taskList = this.taskData[team_id];
      // this.index = index;
      setTimeout(() => {
        this.$refs.taskListModal.open();
      }, 10); // 延迟 200 毫秒
    },
    getDiagramData() {
      this.loading = true;
      taskToQaTime({ ...this.filterForm })
        .then(res => {
          this.team_data = res.data.items;
          this.taskData = res.data.results;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}
</style>
